{
  "version": 1,
  "asset_id": "c3c91722-acae-4621-bc2b-7cdceabf8156",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/c3c91722-acae-4621-bc2b-7cdceabf8156/lecanto-black-shingle-roof-1200w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/c3c91722-acae-4621-bc2b-7cdceabf8156/lecanto-black-shingle-roof-1200w.webp",
  "original_filename": "lecanto-black-shingle-roof-1200w.webp",
  "size": 338326,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:57Z"
}
